import { useEffect } from 'react';

function GPTfyBarista() {
  useEffect(() => {
    const container = document.getElementById('gptfy-barista-mount');
    if (!container || container.hasChildNodes()) return;

    container.innerHTML = `
      <df-messenger
        location="${process.env.REACT_APP_BARISTA_LOCATION}"
        project-id="${process.env.REACT_APP_BARISTA_PROJECT_ID}"
        agent-id="${process.env.REACT_APP_BARISTA_AGENT_ID}"
        language-code="en"
        max-query-length="-1">
        <df-messenger-chat-bubble
          chat-title="GPTfy Barista"
          chat-subtitle=""
          bot-writing-text="Thinking..."
          bot-writing-image="${process.env.PUBLIC_URL}/logo-gptfy-white.png"
          chat-icon="${process.env.PUBLIC_URL}/logo-gptfy-white.png"
          placeholder-text="Type your message...">
        </df-messenger-chat-bubble>
      </df-messenger>
    `;
  }, []);

  return <div id="gptfy-barista-mount" />;
}

export default GPTfyBarista;
